import { Outlet } from "react-router-dom";
import { cn } from "../../../design-system/lib/cn.js";

export default function AuthLayout() {
  return (
    <div className="min-h-screen bg-linear-to-br from-rose-50 to-warm-100 p-4 sm:p-6 lg:p-8">
      <Outlet />
    </div>
  );
}